@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.engineservice.cr

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun CUSCRFlowLayout(
    state: String,
    eingereicht: Boolean,
    letzteNummer: String,
    onBack: () -> Unit,
    onResetToHub: () -> Unit,
    content: @Composable () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center)
            width(100.percent)
            height(100.percent)
            backgroundColor(Color.transparent)
            color(Color.white)
            property("font-family", "Inter, system-ui, sans-serif")
            property("box-sizing", "border-box")
        }
    }) {
        Div({
            style {
                width(100.percent)
                height(100.percent)
                backgroundColor(Color.transparent)
                property("border", "none")
                borderRadius(0.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Row)
                alignItems(AlignItems.Stretch)
                property("box-sizing", "border-box")
                overflow("visible")
                padding(18.px)
            }
        }) {
            Div({
                style {
                    width(72.px)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center)
                    opacity(if (state != "HUB" && !eingereicht) 0.6 else 0.0)
                    property("pointer-events", if (state != "HUB" && !eingereicht) "auto" else "none")
                    cursor("pointer")
                }
                onClick { onBack() }
            }) {
                Img(src = "images/back.svg") {
                    style {
                        width(28.px)
                        height(28.px)
                        property("filter", "brightness(0) invert(1)")
                    }
                }
            }

            Div({
                style {
                    flexGrow(1)
                    padding(40.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center)
                    property("box-sizing", "border-box")
                }
            }) {
                if (eingereicht) {
                    Div({
                        style {
                            flexGrow(1)
                            width(100.percent)
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Column)
                            justifyContent(JustifyContent.Center)
                            alignItems(AlignItems.Center)
                            textAlign("center")
                            gap(16.px)
                        }
                    }) {
                        Img(src = "images/check.svg") {
                            style { width(56.px); property("filter", "brightness(0) invert(1)") }
                        }
                        H2({ style { margin(0.px) } }) { Text("Anfrage eingereicht") }
                        P({
                            style {
                                margin(0.px)
                                color(Color("#8a8f9a"))
                                fontSize(15.px)
                            }
                        }) { Text("Deine Anfrage wurde unter der Nummer $letzteNummer gespeichert.") }
                        Button({
                            style {
                                marginTop(22.px)
                                height(50.px)
                                padding(0.px, 40.px)
                                backgroundColor(Color.white)
                                color(Color.black)
                                fontWeight("bold")
                                borderRadius(8.px)
                                cursor("pointer")
                                property("border", "none")
                            }
                            onClick { onResetToHub() }
                        }) { Text("Zurück zum Hub") }
                    }
                } else {
                    content()
                }
            }

            Div({
                style {
                    width(72.px)
                    opacity(0.0)
                    property("pointer-events", "none")
                }
            }) {}
        }
    }
}

@Composable
internal fun CUSCRHeader(state: String) {
    Div({
        style {
            width(100.percent)
            maxWidth(600.px)
            textAlign("center")
        }
    }) {
        when (state) {
            "NEU" -> H2({ style { margin(0.px) } }) { Text("Neues Modul beauftragen") }
            "AENDERUNG" -> H2({ style { margin(0.px) } }) { Text("Bestehenden Screen anpassen") }
            else -> Unit
        }
    }
}

@Composable
internal fun CUSCRBody(state: String, content: @Composable () -> Unit) {
    Div({
        style {
            flexGrow(1)
            width(100.percent)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(if (state == "HUB") JustifyContent.Center else JustifyContent.FlexStart)
            property("box-sizing", "border-box")
        }
    }) { content() }
}

@Composable
internal fun CUSCRHub(
    onNeu: () -> Unit,
    onAenderung: () -> Unit,
    onListe: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            gap(32.px)
            width(100.percent)
            justifyContent(JustifyContent.Center)
        }
    }) {
        CRRoleCard("Neues Modul", "images/modulverwaltung.svg", onNeu)
        CRRoleCard("Anpassung", "images/settings.svg", onAenderung)
        CRRoleCard("Anträge", "images/cr.svg", onListe)
    }
}
